package one.primehealth.app.di

import one.primehealth.app.AppLifecycleChannel
import one.primehealth.app.AppRestartController
import one.primehealth.app.DeepLinkChannel
import one.primehealth.app.UserDataManager
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val baseAppModule = module {
    singleOf(::AppRestartController)
    singleOf(::AppLifecycleChannel)
    singleOf(::DeepLinkChannel)
    single { UserDataManager(getAll()) }
}